import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of, OperatorFunction, pipe } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../../../app.config';
import {
    mapList,
    mapRetrieve,
    mapUpdate,
} from '../../../common/rest.operators';
import { ObjectDateTransformer } from '../../coaching-insight.model';
import { ScheduleEvent } from '../models/schedule-event.model';
import { ScheduleItem } from '../models/schedule.model';

@Injectable()
export class ScheduleService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    getScheduleByUser(
        performerUserId: number,
        startDate: Date,
        endDate: Date,
    ): Observable<ScheduleItem[]> {
        const params = new HttpParams()
            .set('performerUserId', performerUserId.toString())
            .set('startDate', startDate.toJSON())
            .set('endDate', endDate.toJSON());

        return this._http
            .get(
                `${this._appConfig.API_ENDPOINTS.COACHING}/coaching-insight/schedule`,
                { params },
            )
            .pipe(
                mapList(),
                tap((ret) => {
                    const dateTransformer =
                        new ObjectDateTransformer<ScheduleItem>({
                            eventDate: null,
                        });

                    ret = ret.map((a) => {
                        const f = dateTransformer.transform(a);

                        return f;
                    });
                }),
                catchError((e) => {
                    console.error('error api', e);
                    return of([]);
                }),
            );
    }

    createEvent<T>(
        project: (value: T, index: number) => ScheduleEvent,
    ): OperatorFunction<T, ScheduleEvent> {
        return pipe(
            switchMap((value, index) => {
                const body = project(value, index);
                return this._http.post(
                    `${this._appConfig.API_ENDPOINTS.COACHING}/coaching-insight/scheduleevent`,
                    body,
                );
            }),
            mapUpdate(),
            catchError((e) => of(null)),
        );
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getEvent<T>(eventId: number): Observable<ScheduleEvent> {
        return this._http
            .get(
                `${this._appConfig.API_ENDPOINTS.COACHING}/coaching-insight/scheduleevent/${eventId}`,
            )
            .pipe(
                mapRetrieve(),
                catchError((e) => {
                    console.error('error api', e);
                    return of([]);
                }),
            );
    }

    updateEvent<T>(
        project: (value: T, index: number) => ScheduleEvent,
    ): OperatorFunction<T, ScheduleEvent> {
        return pipe(
            switchMap((value, index) => {
                const body = project(value, index);

                return this._http.patch(
                    `${this._appConfig.API_ENDPOINTS.COACHING}/coaching-insight/scheduleevent/${body.eventId}`,
                    body,
                );
            }),
            mapUpdate(),
            catchError((e) => of(null)),
        );
    }
}
